import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Button
} from '@mui/material';
import dayjs from 'dayjs';

import { STRINGS } from 'src/commons';

const CustomTable = ({
  data = [],
  headers = [],
  dataKeysSequence = [],
  limit = 10,
  handlePageChange = () => {},
  onEdit = () => {},
  onDelete = () => {},
  page = 0,
  NO_DATA_MESSAGE = STRINGS.NO_DATA_FOUND
}) => {
  return (
    <>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(0, limit)?.length ? (
                data.slice(0, limit).map((dataItem, index) => (
                  <TableRow hover key={index}>
                    {dataKeysSequence?.map((key, itemIndex) => (
                      <TableCell key={itemIndex}>
                        {key === 'start_time' ? (
                          `${dayjs(dataItem[key]).format('hh:mm A')}`
                        ) : key === 'end_time' ? (
                          `${dayjs(dataItem[key]).format('hh:mm A')}`
                        ) : key === 'actions' ? (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '.8rem'
                            }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              onClick={() => {
                                onEdit(dataItem);
                              }}
                              color="error"
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                textTransform: 'none'
                              }}
                              onClick={() => {
                                onDelete(dataItem);
                              }}
                              color="success"
                            >
                              Delete
                            </Button>
                          </Box>
                        ) : (
                          dataItem[key]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow hover>
                  <TableCell colSpan={headers.length}>
                    {NO_DATA_MESSAGE}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={data?.length}
        onPageChange={handlePageChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
      />
    </>
  );
};

export default CustomTable;
